import { render, staticRenderFns } from "./BannerLobEdit.vue?vue&type=template&id=52a07811&"
import script from "./BannerLobEdit.vue?vue&type=script&lang=js&"
export * from "./BannerLobEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports